<template>
  <PrintAgenda
    :agenda="agendaStore.agenda"
    :conferences="conferenceStore.conferences"
    :school="schoolStore.school"
    :user="authenticationStore.me"
  />
</template>

<script setup>
import { onMounted } from "vue";

import PrintAgenda from "@/components/teacher/PrintTeacherAgenda.vue";
import { useAgendaStore } from "@/stores/teacher/agenda";
import { useConferenceStore } from "@/stores/teacher/conference";
import { useSchoolStore } from "@/stores/school";
import { useAuthenticationStore } from "@/stores/authentication";
import { useRoute } from "vue-router";

const props = defineProps({
  conferences: Array,
  school: Array,
  agenda: Array,
  user: Object
});
console.log(props.agenda);

const conferenceStore = useConferenceStore();
const schoolStore = useSchoolStore();
const agendaStore = useAgendaStore();
const authenticationStore = useAuthenticationStore();
const route = useRoute();

onMounted(() => {
  try {
    agendaStore.loadAgenda().then(() => {
      console.log("Agenda Loaded");
    });
    // conferenceStore.fetchConferences().then((result) => {
    //   console.log("Conference Data Loaded");
    // });
    authenticationStore.fetchProfile().then(() => {
      console.log("Profile Loaded...");
    });
  } catch (e) {
    console.log(e);
  }
  console.log("do we have a school loaded");
  if (schoolStore.school == null || schoolStore.school?.school_id == undefined) {
    if (route.params.account != null && route.params.account != "") {
      schoolStore.loadSchool(route.params.account).then(() => {
        console.log("School found");
      });
    } else {
      window.location.href = "https://www.ptcwizard.com";
    }
  }
});
</script>
